<div class="duna-cprng-orgsettings-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>CPRNG org-indstillinger</h1></mat-card-title>
      <mat-card-subtitle>
        Rediger organisations-data (JSONB), CPRNG-features og lokations-specifik adgang.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions align="end">
      <button mat-stroked-button (click)="loadOrganizations()" [disabled]="loadingOrgs">
        Opdater org-liste
      </button>
    </mat-card-actions>
  </mat-card>

  @if (errorMessage) {
    <mat-card class="message-card message-card--error">
      <mat-card-content><p>{{ errorMessage }}</p></mat-card-content>
    </mat-card>
  }
  @if (successMessage) {
    <mat-card class="message-card message-card--success">
      <mat-card-content><p>{{ successMessage }}</p></mat-card-content>
    </mat-card>
  }

  <div class="layout">
    <mat-card class="org-list-card">
      <mat-card-header>
        <mat-card-title>Organisationer</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="key-field" style="width: 100%">
          <mat-label>Søg</mat-label>
          <input matInput [(ngModel)]="orgSearch" (ngModelChange)="filterOrgs()" />
        </mat-form-field>
        @if (loadingOrgs) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <ul class="org-list">
          @for (org of filteredOrgs; track org.id) {
            <li>
              <button
                mat-stroked-button
                class="org-list-item"
                [class.org-list-item--active]="selectedOrgId === org.id"
                (click)="selectOrg(org)"
              >
                {{ org.org_name }} ({{ org.id }})
              </button>
            </li>
          }
        </ul>
      </mat-card-content>
    </mat-card>

    <div>
      @if (!selectedOrgId) {
        <mat-card class="detail-card">
          <mat-card-content>
            <p class="muted">Vælg en organisation i listen.</p>
          </mat-card-content>
        </mat-card>
      } @else {
        <mat-card class="detail-card">
          <mat-card-header>
            <mat-card-title>{{ selectedOrgName }}</mat-card-title>
            <mat-card-subtitle>ID {{ selectedOrgId }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            @if (loadingDetail) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <h3>CPRNG-features</h3>
            <p class="muted">
              Hele organisationen giver alle medlemmer adgang. Uden org-toggle kan du vælge lokationer
              (kun primær/sekundær på disse steder).
            </p>
            @for (def of featureDefs; track def.key) {
              <div class="feature-row">
                <span class="feature-label">{{ def.label }}</span>
                <mat-slide-toggle
                  [checked]="featureState[def.key].org_enabled"
                  (change)="onOrgEnabledChange(def.key, $event.checked)"
                >
                  Hele organisationen
                </mat-slide-toggle>
                <mat-form-field appearance="outline">
                  <mat-label>Lokationer</mat-label>
                  <mat-select
                    multiple
                    [disabled]="featureState[def.key].org_enabled"
                    [(ngModel)]="featureState[def.key].location_ids"
                  >
                    @for (loc of locations; track loc.id) {
                      <mat-option [value]="loc.id">{{ loc.locations_name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <div class="actions-row">
              <button
                mat-raised-button
                color="primary"
                (click)="saveFeatures()"
                [disabled]="saving || loadingDetail"
              >
                {{ saving ? 'Gemmer…' : 'Gem features' }}
              </button>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="detail-card">
          <mat-card-header>
            <mat-card-title>Org data (JSONB)</mat-card-title>
            <mat-card-subtitle>Rediger felter, objekter og lister — uden rå JSON.</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <app-org-data-json-editor
              [data]="dataForJsonEditor"
              [excludedKeys]="[cprngFeaturesKey]"
              [excludedHint]="cprngFeaturesExcludedHint"
              (dataChange)="onOrgDataEditorChange($event)"
            />
            <div class="actions-row">
              <button
                mat-raised-button
                color="primary"
                (click)="saveOrgData()"
                [disabled]="saving || loadingDetail"
              >
                {{ saving ? 'Gemmer…' : 'Gem org data' }}
              </button>
              <button
                mat-stroked-button
                (click)="resetOrgDataFromServer()"
                [disabled]="loadingDetail"
              >
                Nulstil fra server
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
